import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';

const HistoryRow = ({ historyItem }) => {

    const historyTemplate = () => {

        let itemsToDisplay = [];

        historyItem.additionalInfoOld = Object.prototype.hasOwnProperty.call(historyItem, 'additionalInfoOld') ? historyItem.additionalInfoOld : "";
        historyItem.additionalInfoNew = Object.prototype.hasOwnProperty.call(historyItem, 'additionalInfoNew') ? historyItem.additionalInfoNew : "";
        
        if (historyItem.additionalInfoOld !== historyItem.additionalInfoNew) {
            itemsToDisplay.push({displayName: 'Additional Information', oldData: historyItem.additionalInfoOld, newData: historyItem.additionalInfoNew});
        }

        if (historyItem.nameOld !== historyItem.nameNew) {
            itemsToDisplay.push({displayName: 'Name', oldData: historyItem.nameOld, newData: historyItem.nameNew});
        }

        if (historyItem.startDateOld !== historyItem.startDateNew) {
            itemsToDisplay.push({displayName: 'Start Date', oldData: Moment.utc(historyItem.startDateOld).format(DATE_FORMAT), newData: Moment.utc(historyItem.startDateNew).format(DATE_FORMAT)});
        }

        if (historyItem.statusOld !== historyItem.statusNew) {
            itemsToDisplay.push({displayName: 'Status', oldData: historyItem.statusOld, newData: historyItem.statusNew});
        }

        if (historyItem.targetDateOld !== historyItem.targetDateNew) {
            itemsToDisplay.push({displayName: 'Target Date', oldData: Moment.utc(historyItem.targetDateOld).format(DATE_FORMAT), newData: Moment.utc(historyItem.targetDateNew).format(DATE_FORMAT)});
        }

        if (historyItem.responsibleUserOld !== historyItem.responsibleUserNew) {
            itemsToDisplay.push({displayName: 'Responsible User', oldData: historyItem.responsibleUserOld, newData: historyItem.responsibleUserNew});
        }

        if (historyItem.targetDaysOutOld !== historyItem.targetDaysOutNew) {
            itemsToDisplay.push({displayName: 'Target Days Out', oldData: historyItem.targetDaysOutOld, newData: historyItem.targetDaysOutNew});
        }

        historyItem.budgetOld = Object.prototype.hasOwnProperty.call(historyItem, 'budgetOld') ? historyItem.budgetOld : 0;
        historyItem.budgetNew = Object.prototype.hasOwnProperty.call(historyItem, 'budgetNew') ? historyItem.budgetNew : 0;
        historyItem.actualOld = Object.prototype.hasOwnProperty.call(historyItem, 'actualOld') ? historyItem.actualOld : 0;
        historyItem.actualNew = Object.prototype.hasOwnProperty.call(historyItem, 'actualNew') ? historyItem.actualNew : 0;

        if (historyItem.budgetOld !== historyItem.budgetNew) {
            itemsToDisplay.push({displayName: 'Budget', oldData: historyItem.budgetOld, newData: historyItem.budgetNew});
        }

        if (historyItem.actualOld !== historyItem.actualNew) {
            itemsToDisplay.push({displayName: 'Actual', oldData: historyItem.actualOld, newData: historyItem.actualNew});
        }

        return itemsToDisplay;
    }

    const changedTemplate = () => {
        //the assumption is the first item in the array will be the 'created task' record
        if (historyItem.id === 0) {
            return ' created task.'
        }

        return ' changed ';
    }

    return (
        <div className="list-group-item list-group-item-action flex-column align-items-start">
            <p className="mb-1">
                <strong>
                    {historyItem.createdBy}
                </strong>
                {changedTemplate()}
                {historyTemplate().map((item, index) => 
                    <span key={index}>
                        {index ? ', ' : ''}<strong>{item.displayName}</strong> from <strong>{item.oldData}</strong> to <strong>{item.newData}</strong>
                    </span>
                )}
                
            </p>
            <small>{Moment.utc(historyItem.created).format(DATE_FORMAT)}</small>
        </div>
    );

}

HistoryRow.propTypes = {
    historyItem: PropTypes.object.isRequired
};

export default HistoryRow;